import type { ReactNode } from 'react'
import { CircleHelp } from 'lucide-react'
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from '@/components/ui/item'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type FunnelStatItemProps = {
  label: string
  percent: number
  description: string
  tooltip?: string
  icon?: ReactNode
}

export function FunnelStatItem({
  label,
  percent,
  description,
  tooltip,
  icon,
}: FunnelStatItemProps) {
  return (
    <Item variant='outline' size='xs' className='items-center'>
      {icon != null && (
        <ItemMedia variant='icon' className='self-center'>
          {icon}
        </ItemMedia>
      )}
      <ItemContent className='min-w-0'>
        <ItemTitle className='text-xs font-medium text-muted-foreground'>
          <span className='inline-flex items-center gap-1'>
            {label}
            {tooltip != null && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <button
                    type='button'
                    className='inline-flex text-muted-foreground/70 hover:text-muted-foreground'
                    aria-label={tooltip}
                  >
                    <CircleHelp className='size-3.5' aria-hidden />
                  </button>
                </TooltipTrigger>
                <TooltipContent side='top' className='max-w-xs'>
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            )}
          </span>
        </ItemTitle>
        <ItemDescription>{description}</ItemDescription>
      </ItemContent>
      <ItemActions className='shrink-0'>
        <span className='text-lg font-semibold tabular-nums'>{percent}%</span>
      </ItemActions>
    </Item>
  )
}
